
import { Component, Prop, Vue } from 'bits/vue'
import OzBaseButton from 'library/v4/components/OzBaseButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'

export enum OzDropdownButtonSizePreset {
  H40px = 'H40px',
  H32px = 'H32px',
}

export enum OzDropdownButtonColorScheme {
  Secondary = 'Secondary',
  SecondaryClear = 'SecondaryClear',
  SecondaryClearActive = 'SecondaryClearActive',
  SecondaryClearText = 'SecondaryClearText',
}

/**
 * The main differences between OzDropdownButton and OzContainedButton are:
 *
 * - Font weight
 * - Text color
 * - Transparent background instead of disabled color background
 * - No active state
 * - Padding
 * - Space between text and icon
 */

@Component({
  components: {
    OzBaseButton,
    OzIcon,
  },
})
export default class OzDropdownButton extends Vue {
  SizePreset = OzDropdownButtonSizePreset
  ColorScheme = OzDropdownButtonColorScheme

  /**
   * Dark mode.
   * @default 'auto'
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Direction.
   * @default 'auto'
   */
  @Prop({ default: 'auto' }) dir!: 'ltr' | 'rtl' | 'auto'

  /**
   * Applies preset sizes/shapes.
   * @default OzDropdownButtonSizePreset.H40px
   */
  @Prop({ default: OzDropdownButtonSizePreset.H40px }) sizePreset!: OzDropdownButtonSizePreset

  /**
   * Applies preset color scheme.
   * @default OzDropdownButtonColorScheme.Secondary
   */
  @Prop({ default: OzDropdownButtonColorScheme.Secondary }) colorScheme!: OzDropdownButtonColorScheme

  /**
   * Text to display.
   * @default undefined
   */
  @Prop({ default: undefined }) text?: string

  /**
   * Name of the icon displayed inline start in the button.
   * @default undefined
   */
  @Prop({ default: undefined }) startIconName?: string

  /**
   * Determines if dropdown button is disabled
   * @default false
   */
  @Prop({ default: false }) disabled!: boolean

  /**
   * Defines whether the button text should be truncated or not.
   * Use case:
   *
   * 1. `true` - truncate the button text if it exceeds the button's width
   * 2. `false` - do not truncate the button text, allowing it to stretch the button's height
   * @default false
   */
  @Prop({ default: false }) shouldTruncateText!: boolean
}
